import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n";
import { WA_NUMBER } from "../lib/site";

const AppContext = createContext(null);

const getInitialLang = () => {
  try {
    const saved = localStorage.getItem("nta-lang");
    if (saved === "id" || saved === "en") return saved;
    return (navigator.language || "id").toLowerCase().startsWith("id") ? "id" : "en";
  } catch {
    return "id";
  }
};

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem("nta-theme");
    if (saved === "dark" || saved === "light") return saved;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    try { localStorage.setItem("nta-lang", lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    try { localStorage.setItem("nta-theme", theme); } catch {}
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const t = translations[lang];
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(t.waMessage)}`;

  return (
    <AppContext.Provider value={{ lang, setLang, theme, setTheme, t, waLink }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
